import { Line } from 'vue-chartjs/src/BaseCharts';

export default {
  extends: Line,
  props: ['reload'],
  data() {
    return {
      options: { responsive: true, maintainAspectRatio: false },
      data: {
        labels: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
        ],
        datasets: [
          {
            label: 'Productivity',
            backgroundColor: 'rgba(34, 151, 205, 0.65)',
            data: [10, 13, 23, 40, 43, 80, 140],
          },
        ],
      },
    };
  },
  mounted() {
    this.renderChart(this.data, this.options);
    document
      .getElementById('main-content')
      .addEventListener('resize', this.redraw);
  },
  methods: {
    redraw() {
      this.renderChart(this.data, this.options);
    },
  },
  destroyed() {
    document
      .getElementById('main-content')
      .removeEventListener('resize', this.redraw);
  },
};
